import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import moment from 'moment';
import { intlShape } from '../../../components/base/IntlProviderWrapper';
import './authorized.scss';
import {
  createRepresentative, editRepresentative, loadRepresentativeById, loadRepresentativeList,
} from '../actions';
import {
  getFilterData, getPaginationOpts, getResponseError, responseLogWithNotification,
} from '../../../utils/utils';
import { getClientPersonalData, getProfileData } from '../reducer';
import Loader from '../../../components/base/Loader/Loader';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { AUTHORIZED_MODULE } from '../../../configs/moduleNames';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import { dateFormatter, localeFormatter, userShortFIOFormatter } from '../../../utils/formatters';
import { InviteFormModal } from './Form/InviteFormModal';
import { RepresentativeInviteFormModal } from './Form/RepresentativeInviteFormModal';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { addGlobalPopUpWrapper } from '../../InformationScreenWrapper/actions';
import { POPUP_LIST_NAME } from '../../../configs';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import Pagination from '../../../components/base/Pagination/Pagination';
import { RepresentativeEditFormModal } from './Form/RepresentativeEditFormModal';
import { LOCAL_STORAGE_APPLICANT_KEY } from '../../../configs/names';

export function UserRepresentativeDataView(props) {
  const {
    formatMessage,
  } = intlShape;
  const [inviteLink, setInviteLink] = useState('invite');
  const [showInvite, setShowInvite] = useState();
  const [showRepresentativeForm, setShowRepresentativeForm] = useState();
  const [showEditForm, setShowEditForm] = useState();
  const store = useStore();
  const filterName = 'representative-filter';

  const user = useSelector(getClientPersonalData);

  const {
    getValues, control, watch,
  } = useForm({ defaultValues: getFilterData(filterName, {}) });

  const columns = [
    {
      dataField: 'name_for_applicant',
      text: 'Название доверенности',
      disableSort: true,
    },
    {
      dataField: 'created_at',
      text: 'Дата выдачи',
      disableSort: true,
      formatter: dateFormatter,
    },
    {
      dataField: 'validity_period',
      text: 'Срок действия',
      disableSort: true,
      formatter: (item, _) => (item?.is_permanent ? 'Постоянная' : dateFormatter(item?.validity_period)),
    },
    {
      dataField: 'status',
      text: 'Статус',
      disableSort: true,
      formatter: item => localeFormatter('representative.status', item),
    },
    {
      dataField: 'user',
      text: 'Представитель',
      disableSort: true,
      formatter: userShortFIOFormatter,
    },
    {
      dataField: 'type',
      text: 'Тип',
      disableSort: true,
      formatter: item => (item === 'invite' ? 'Приглашение' : 'Довереность'),
    },
    {
      dataField: 'is_applicant_approved',
      text: 'Подтверждение доверителя',
      disableSort: true,
      formatter: (_, item) => (item?.is_applicant_approved ? dateFormatter(item?.applicant_approved_at) : 'Нет'),
    },
    {
      dataField: 'is_user_approved',
      text: 'Подтверждение представителя',
      disableSort: true,
      formatter: (_, item) => (item?.is_user_approved ? dateFormatter(item?.user_approved_at) : 'Нет'),
    },
  ];

  const dispatch = useDispatch();
  const {
    representativeList,
    loadingRepresentativeList,
    representativeListMeta,
    loadingCreateRepresentative,
    loadingEditRepresentative,
  } = useSelector(getProfileData);

  const handleClose = () => {
    setShowInvite(false);
    setShowRepresentativeForm(false);
    setShowEditForm(false);
  };

  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[AUTHORIZED_MODULE].representativeListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: { ...getValues(), user_id: user?.id },
    };
    const p1 = dispatch(loadRepresentativeList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem(filterName, JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  useEffect(() => {
    dispatch(loadRepresentativeList({
      filter: {
        user_id: user?.id,
      },
    })).catch(responseLogWithNotification);
  }, []);

  const handleRename = item => {
    dispatch(loadRepresentativeById(item?.id)).then(() => {
      setShowEditForm(true);
    }).catch(responseLogWithNotification);
  };

  const handleShow = item => {
    dispatch(addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.REPRESENTATIVE_DETAIL, id: item?.id }));
  };

  const edit = item => {
    dispatch(editRepresentative({ ...item })).then(() => {
      setShowEditForm(false);
      loadData({ page: 1 });
    }).catch(responseLogWithNotification);
  };

  const handleCreateRepresentative = body => {
    dispatch(createRepresentative({
      ...body,
      is_applicant_approved: true,
      is_user_approved: false,
      applicant_approved_at: moment().format('YYYY-MM-DDTHH:mm:ss[Z]'),
      type: 'invite',
      status: 'new',
    }))
      .then(response => {
        successNotification('Приглашение представителя', 'Успех');
        setShowRepresentativeForm(false);
        setShowInvite(true);
        setInviteLink(response?.link);
        loadData();
      }).catch(response => { errorNotification('Приглашение представителя', getResponseError(response)); });
  };

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={(
        <div className="more-wrapper">
          <Button variant="link" className="w-100 more-button" onClick={() => handleShow(item)}>
            Посмотреть
          </Button>
          <Button variant="link" className="w-100 more-button" onClick={() => handleRename(item)}>
            Переименовать
          </Button>
          {/* { selectedTab === 'invite' */}
          {/*  ? ( */}
          {/*    <Button variant="link" className="w-100 more-button delete" onClick={handleRejectInvite(item)}> */}
          {/*      Отклонить */}
          {/*    </Button> */}
          {/*  ) : null } */}
        </div>
          )}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  return (
    <div className="uspd-representative-data-view">
      <Loader loading={loadingRepresentativeList || loadingCreateRepresentative || loadingEditRepresentative} global />
      <div className="uspd-representative-data-view-header">
        <div className="uspd-representative-data-view-title">
          <div className="f3">{formatMessage({ id: 'user.profile.menu.representative' })}</div>
          {/* <TabMenu options={[{ value: 'invite', label: 'Приглашения' }, { value: 'fuldmagt', label: 'Доверенности' }]} onSelectOptions={i => setSelectedTab(i.value)} selectedTab={selectedTab} /> */}
        </div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            inputBefore={(
              <div className="search-wrapper">
                <Icons customIcon className="search" width={24} height={24} icon="search" />
              </div>
                )}
          />
          <Button variant="second" onClick={() => setShowRepresentativeForm(true)}>
            <Icons
              customIcon
              className="file-download"
              width={24}
              height={24}
              icon="plus"
            />
          </Button>
        </FilterRow>
      </div>
      <div className="mb-4" />
      <div className="grid-wrapper frame">
        <div className="sticky-table-wrapper custom-scroll-theme">
          <CustomizedGrid
            data={representativeList}
            columns={columns}
            settingsFormatter={moreFormatter}
                // onDoubleClickByRow={item => handleShow(item)}
            onDoubleClickByRow={item => {
              dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.REPRESENTATIVE_DETAIL, id: item?.id })));
            }}
            name="my-representative-list"
            emptyText="Нет представителей"
          />
        </div>
      </div>
      <Pagination meta={representativeListMeta} list={loadingRepresentativeList} handleChangeMeta={loadData} />
      { showRepresentativeForm ? <RepresentativeInviteFormModal onClose={handleClose} onSend={handleCreateRepresentative} /> : null }
      { showInvite ? <InviteFormModal link={inviteLink} onClose={handleClose} /> : null }
      { showEditForm ? <RepresentativeEditFormModal onSend={edit} onClose={handleClose} /> : null }
    </div>
  );
}
